export interface DropdownOption {
  label: string;
  value: string;
}

export const LOCAL_ACCESSORY_OPTIONS: DropdownOption[] = [
  { label: 'Monitor', value: 'Monitor' },
  { label: 'Mouse', value: 'Mouse' },
  { label: 'Keyboard', value: 'Keyboard' },
  { label: 'Docking Station', value: 'Docking Station' },
  { label: 'Headset', value: 'Headset' },
  { label: 'Webcam', value: 'Webcam' },
];

export const LOCATION_OPTIONS: DropdownOption[] = [
  { label: 'Hyderabad', value: 'Hyderabad' },
  { label: 'Gurgaon', value: 'Gurgaon' },
  { label: 'All', value: 'All' },
];

export const INITIAL_LAPTOP_TYPE_OPTIONS: DropdownOption[] = [
  { label: 'HP Elitebook', value: 'HP Elitebook' },
  { label: 'Dell Latitude', value: 'Dell Latitude' },
  { label: 'Lenovo ThinkPad', value: 'Lenovo ThinkPad' },
];

export const RESOURCE_FIELDS: string[] = [
  'email',
  'dateOfJoining',
  'firstName',
  'lastName',
  'DnTLeader',
  'reportingManager',
  'employeeId',
  'location',
];
